import { createContext } from 'react';
import { ContentfulCityContent } from 'src/../graphql-types';

export type CmsContextValue = {
  faq: any;
  cityContents: ContentfulCityContent[];
};

export const CmsContext = createContext<any>({});
